import { Stack } from 'expo-router';
import type { ReactNode } from 'react';
import { withUnistyles } from 'react-native-unistyles';

const UnistylesStack = withUnistyles(Stack, (theme) => ({
  screenOptions: {
    contentStyle: {
      backgroundColor: theme.colors.background,
    },
    headerStyle: {
      backgroundColor: theme.colors.background,
    },
    headerShadowVisible: false,
    headerTintColor: theme.colors.typography,
    headerTitle: '',
  },
}));

export default function TabStack({ children }: { children?: ReactNode }) {
  return <UnistylesStack>{children}</UnistylesStack>;
}
